import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Prompt } from 'react-router-dom';
import { setAlertActionCreator } from 'plugins/store/reducers/common.reducer';

export class RouteLeavingGuard extends Component {

	state = {
		lastLocation: null,
		confirmedNavigation: false,
	};

	showModal = (location) => {
		const { setAlert, alertCustomProps } = this.props;
		this.setState({
			lastLocation: location,
		});
		const warning = {
			type: 'warning',
			title: 'You have unsaved changes',
			message: 'Are you sure you want to leave the page?',
			confirmBtnText: 'Leave',
			cancelBtnText: 'Stay',
			onConfirm: async () => {
				this.handleConfirmNavigationClick();
			},
			onCancel: () => {
				setAlert(null);
			},
			...alertCustomProps,
		};
		setAlert(warning);
	}

	handleBlockedNavigation = (nextLocation) => {
		if (!this.props.isAuth) {
			return true;
		}

		const { confirmedNavigation } = this.state;
		const { shouldBlockNavigation } = this.props;

		if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
			this.showModal(nextLocation);
			return false;
		}

		return true;
	}

	handleConfirmNavigationClick = () => {
		const { navigate, setAlert } = this.props;
		const { lastLocation } = this.state;

		setAlert(null);

		if (lastLocation) {
			this.setState({
				confirmedNavigation: true
			}, () => {
				navigate(lastLocation.pathname)
			})
		}
	};

	render() {
		const { when } = this.props;

		return (
			<Prompt
				when={when}
				message={this.handleBlockedNavigation} />
		);
	}
}

const mapStateToProps = ({ auth: { auth } }) => ({
	isAuth: !!auth,
});

const mapDispatchToProps = (dispatch) => ({
	setAlert: bindActionCreators(setAlertActionCreator, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteLeavingGuard);
